<template>
    <div class="bottom-menu" :class="{ 'is-double': isDouble, 'is-open': is_open }">
        <div class="bottom-menu-container">
            <estates-list-menu
                v-if="isEstatesList"
                :search="search"
                :title="title"
            />

            <estate-detail-menu
                v-if="isEstateDetail"
                :estate="estate"
                :config_estate="config_estate"
            />

            <div
                v-if="isDouble"
                class="divider"
                @click="toggle"
            >
                <div class="divider-glyph"></div>
            </div>
        </div>
        
        <user-menu
            v-if="!showcase"
            :config_footer="config_footer"
        />

        <modal
            v-if="isEstatesList && lang"
            name="save_search"
            ref="save_search"
            :title="lang.estates_list_menu.titles.save_search"
            extra-class="bottom-modal save-search-modal"
        >
            <template slot="body">
                <save-search-form 
                    :search="estatesFilters"
                    :title="title_search"
                    :map_center="map_center"
                    :map_polygons="map_polygons"
                />
            </template>
        </modal>
    </div>
</template>

<script>
import EstateDetailMenu from './EstateDetailMenu'
import EstatesListMenu from './EstatesListMenu'
import Modal from './Modal'
import SaveSearchForm from './SaveSearchForm'
import UserMenu from './UserMenu'

import { isEmpty } from '../helpers/objects'

export default {
    components: {
        'estate-detail-menu': EstateDetailMenu,
        'estates-list-menu': EstatesListMenu,
        'modal': Modal,
        'save-search-form': SaveSearchForm,
        'user-menu': UserMenu,
    },

    props: {
        config_estate: {
            type: Object,
            required: false,
        },

        config_footer: {
            type: Object,
            required: false,
        },

        estate: {
            type: Object,
            required: false,
        },

        route: {
            type: String,
            required: true,
        },

        search: {
            type: Object,
            required: false,
        },

        map_center: {
            type: [Array, Boolean],
            required: false,
        },

        title: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            client_search: {},
            title_search: this.title,
            is_open: false,
            map_polygons: false,
            map_polygons_base_features: false,
            showcase: window.showcase
        }
    },

    computed: {
        isDouble() {
            return (this.isEstatesList || this.isEstateDetail) && this.$root.is_mobile
        },

        isEstateDetail() {
            return this.route == 'estates.show' || this.route == 'estates.show_region'
        },

        isEstatesList() {
            return this.route.includes('estates.index')
        },

        lang() {
            return this.$root.lang.bottom_menu
        },

        estatesFilters() {
            if (!isEmpty(this.client_search)) {
                return this.client_search
            } else {
                return this.search
            }

            // return {
            //     ...this.search,
            //     ...this.client_search
            // }
        }
    },

    mounted() {
        this.client_search = this.search

        window.events.$on('bottommenu.map.polygons', (event) => {
            this.map_polygons = event
            this.map_polygons_base_features = event.features
        })

        window.events.$on('bottommenu.map.polygons.features', (event) => {
            if (!this.map_polygons) {
                this.map_polygons = []
            }

            if (event) {
                this.map_polygons.features = [
                    ...this.map_polygons_base_features ?? [],
                    ...event
                ]
            } else {
                this.map_polygons.features = this.map_polygons_base_features
            }
        })

        window.events.$on('list.update.filters', (event) => {
            this.map_polygons_base_features = event.features
            this.client_search = event
        })

        window.events.$on('list.update.filters.polygon_id', (event) => {
            this.client_search = {
                ...this.client_search,
                polygon: event,
                polygon_id: event
            }
        })

        window.events.$on('list.title', (event) => {
            this.title_search = event
        })
    },

    methods: {
        swipeDown() {
            this.is_open = false
        },

        swipeUp() {
            this.is_open = true
        },

        toggle() {
            this.is_open = ! this.is_open
        },
    },
}
</script>